import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218bdc82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FrontPage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "News NormalPaddings" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Toivoa elämään"),
  /*#__PURE__*/_createElementVNode("p", null, "Enkelit antavat toivoa elämääsi, uskoa mennä oikeaan suuntaan ja eteenpäin."),
  /*#__PURE__*/_createElementVNode("p", null, "Juuri nytkin enkelisi kuuntelee ja opastaa sinua."),
  /*#__PURE__*/_createElementVNode("p", null, "Ole herkkä, pysähdy ja tunne johdatus."),
  /*#__PURE__*/_createElementVNode("p", null, "- ote Margitin kirjasta \"Taivaan Lahja\"")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "News2 NormalPaddings" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://enkelinesiliina.fi:8080/images/wide/0071fde0-cab8-4401-b5fd-14cc2e836a16.png",
    alt: "Sydämesi ääni"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import HomeButton from "../components/HomeButton.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})